import { CheckboxActiveIcon } from "app/components/Icons";
import CheckboxIcon from "app/components/Icons/CheckboxIcon";
import DragIcon from "app/components/Icons/DragIcon";
import clsx from "clsx";
import React from "react";
import ColumnOptionsMenu from "../../../Home/components/ColumnOptionsMenu";
import { RowFirstColProps } from "./types";

const RowActions: React.FC<RowFirstColProps> = ({
  onArchive,
  onDuplicate,
  isSelected,
  onCheckboxClick,
  ticket,
  projectId,
  showActions,
  setShowActions,
}) => {
  return (
    <div
      className={clsx(
        "flex items-center h-full  absolute -left-[63px] w-[63px] ",
        isSelected ? "!bg-[#E7F1FF]" : " group-hover:bg-gray-200 bg-gray-400 ",
      )}
    >
      <div className={`flex items-center gap-[2px] w-full   `}>
        <button
          className=" size-[18px] flex justify-center items-center opacity-0 group-hover:opacity-100 "
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <DragIcon size={18} />
        </button>
        {isSelected ? (
          <button
            className="size-[18px] flex items-center "
            onClick={(e) => {
              e.stopPropagation();
              onCheckboxClick(ticket);
            }}
          >
            <CheckboxActiveIcon />
          </button>
        ) : (
          <button
            className="size-[18px] flex items-center opacity-0 group-hover:opacity-100 "
            onClick={(e) => {
              e.stopPropagation();
              onCheckboxClick(ticket);
            }}
          >
            <CheckboxIcon size={18} />
          </button>
        )}
        <div className={clsx("group-hover:opacity-100 transition-opacity duration-200", showActions ? "opacity-100" : "opacity-0")}>
          <ColumnOptionsMenu
            onArchive={() => {
              onArchive && onArchive();
            }}
            onDuplicate={() => {
              onDuplicate && onDuplicate();
            }}
            showActions={showActions as boolean}
            setShowActions={
              setShowActions as React.Dispatch<React.SetStateAction<boolean>>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default RowActions;
